export default __webpack_public_path__ + "static/media/cardtrader-logo.0358214a.svg";